import { eSearchGet } from '../api/eSearch';
export const getSuggestGlobal = async ({ term, count = 5, lang = 'en_US', categories, fuzziness, filteredTerms }, logger) => {
    const queryParams = new URLSearchParams();
    queryParams.append('term', term || '');
    queryParams.append('count', count.toString());
    filteredTerms && queryParams.append('filteredTerms', filteredTerms);
    lang && queryParams.append('lang', lang.replace(/es-.*/, 'es-ES').replace('-', '_'));
    categories && queryParams.append('categories', categories);
    fuzziness !== undefined && queryParams.append('fuzziness', fuzziness.toString());
    return await eSearchGet(`suggest/global?${queryParams}`, {}, logger);
};
